import { useEffect, useState } from 'react'

type LocationSelection = {
  label: string
  value: string
}

type LocationOption = {
  label: string
  value: string
}

/**
 * Custom hook to manage reservation location selection
 * @param options - Array of location options
 * @returns Object containing selectedLocation and dropdownDisabled state
 */
export const useSelectReservationLocation = (options: LocationOption[]) => {
  const [selectedLocation, setSelectedLocation] = useState<LocationSelection>({
    label: '',
    value: ''
  })
  const [dropdownDisabled, setDropdownDisabled] = useState(false)

  useEffect(() => {
    if (options.length === 1 && options[0] && !selectedLocation.value) {
      setSelectedLocation({
        label: options[0].label,
        value: options[0].value
      })
      setDropdownDisabled(true)
    }
  }, [options.length, selectedLocation.value, options])

  return {
    selectedLocation,
    setSelectedLocation,
    dropdownDisabled
  }
}
